<!-- Trigger button lives in the app toolbar; this component renders only the
dropdown panel (outside the backdrop-filtered header so position:fixed works). -->
@if (isOpen$ | async) {
  <div class="notif-overlay" (click)="close()"></div>
  <div class="notif-panel">
    <div class="notif-panel-header">
      <span>{{ 'notifications.header' | translate }}</span>
      @if ((unreadCount$ | async)! > 0) {
        <button class="notif-read-all" (click)="markAllRead()">{{ 'notifications.markAllRead' | translate }}</button>
      }
    </div>
    @if (notifications.length === 0) {
      <div class="notif-empty">
        <ion-icon name="notifications-off-outline"></ion-icon>
        <span>{{ 'notifications.empty' | translate }}</span>
      </div>
    }
    <div class="notif-list">
      @for (n of notifications; track n) {
        <button type="button" class="notif-item" [class.notif-item--unread]="!n.isRead"
          (click)="markRead(n.id)">
          <div class="notif-item-icon-wrap">
            <ion-icon class="notif-item-icon" [name]="notificationIcon(n.type)"></ion-icon>
          </div>
          <div class="notif-item-body">
            <span class="notif-item-title">{{ ('notifications.' + n.type + '.title') | translate }}</span>
            <span class="notif-item-msg">{{ ('notifications.' + n.type + '.message') | translate }}</span>
            <span class="notif-item-time">{{ n.createdAt | date:'dd.MM.yyyy, HH:mm' }}</span>
          </div>
        </button>
      }
    </div>
  </div>
}
